import { useState } from 'react';
import { Form, Checkbox } from 'antd';

import { useI18n } from 'context/i18n';
import { useLocale, useValidate } from 'hooks';

import OldProtectionDataModal from 'components/protectionDataModal';
import { PrivacyPolicyText } from 'components/legalTexts';

import { IS_CAMPER } from 'utils/constants/system';

import styles from './style.module.css';
import { getDomainValue } from 'utils/domain';

type PrivacyPolicyProps = {
  origin?: string;
  wrapperClass?: string;
  checkBoxClass?: string;
  hideConditions?: boolean;
  overrideLabel?: any;
  doubleConfirmation?: boolean;
};

export function PrivacyPolicy({
  origin = 'newsletter',
  wrapperClass = '',
  checkBoxClass,
  hideConditions = false,
  overrideLabel = false,
  doubleConfirmation = false,
}: PrivacyPolicyProps) {
  const { t, profileData } = useI18n();
  const { country } = useLocale();
  const validate = useValidate();
  const [dataModalVisible, setDataModalVisible] = useState(false);

  const classForCheckbox = checkBoxClass === undefined ? styles.privacyCheckbox : `${styles.privacyCheckbox} ${checkBoxClass}`;

  const becomeMemberPart = overrideLabel || (
    <>
      {t('compra.formulario', 'become.member')}
      {country === 'TR' && (
        <span>
          <br />
          {t('compra.formulario', 'informacion.comercial.tr')}
        </span>
      )}
    </>
  );

  return (
    <>
      {!doubleConfirmation && (
        <Form.Item className={wrapperClass}>
          <div className={styles.privacyWrapper}>
            <p className={styles.infoLink} onClick={() => setDataModalVisible(true)}>
              {t(
                'generico',
                getDomainValue({
                  camper: 'camper.newsletter.proteccion.datos',
                  nnormal: 'newsletter.proteccion.datos',
                  camperlab: 'camper.newslab.proteccion.datos',
                }),
                'Data protection information',
              )}
            </p>
          </div>
        </Form.Item>
      )}
      <Form.Item name="privacy" valuePropName="checked" rules={validate('privacyPolicy')}>
        <Checkbox tabIndex={27} className={country !== 'TR' ? classForCheckbox : `${classForCheckbox} ${styles.withMargin}`}>
          {country === 'US' ?
            <PrivacyPolicyText className={styles.privacyAgreement} />
          : <span className={styles.privacyAgreement}>
              {t('compra.formulario', 'acepto.las')}&nbsp;
              {!hideConditions && (
                <>
                  <a href={profileData.urlTermsAndConditions} target="_blank" rel="noreferrer">
                    {t('compra.formulario', 'condiciones.generales')}
                  </a>
                  &nbsp;
                  {t('compra.formulario', 'y.la')}&nbsp;
                </>
              )}
              <a href={profileData.urlPrivacyPolicy} target="_blank" rel="noreferrer">
                {t('generico', 'privacy.conditions', 'privacy conditions')}
              </a>
              &nbsp;
              {becomeMemberPart}
            </span>
          }
        </Checkbox>
      </Form.Item>
      {doubleConfirmation && (
        <Form.Item name="confirmation" valuePropName="checked" rules={validate('privacyPolicy')}>
          <Checkbox tabIndex={28} className={country !== 'TR' ? classForCheckbox : `${classForCheckbox} ${styles.withMargin}`}>
            <span className={styles.privacyAgreement}>
              {t('compra.formulario', 'acepto.las')}&nbsp;
              <a href={'https://www.kilianjornet.cat/en/privacy%E2%80%94policy'} target="_blank" rel="noreferrer">
                {t('generico', 'privacy.conditions.kilian')}
              </a>
              &nbsp;
              {t('compra.formulario', 'become.member.kilian')}
            </span>
          </Checkbox>
        </Form.Item>
      )}
      <OldProtectionDataModal visible={dataModalVisible} onCancel={() => setDataModalVisible(false)} origin={origin} />
    </>
  );
}
